import React, { forwardRef } from "react";

import {
  Box,
  Button,
  ButtonProps,
  Typography,
  TypographyProps,
} from "@mui/material";

interface Props extends Omit<ButtonProps, "children"> {
  icon: React.ReactNode;
  children: TypographyProps["children"];
}

// eslint-disable-next-line react/display-name
export const TextButtonWithIcon = forwardRef<HTMLButtonElement, Props>(
  ({ children, icon, ...props }, ref) => {
    return (
      <Button
        ref={ref}
        type="button"
        variant="text"
        sx={(theme) => ({
          alignItems: "center",
          backgroundColor: "transparent",
          border: 0,
          color: "text.primary",
          cursor: "pointer",
          display: "flex",
          height: "auto",
          padding: 0,
          "&:hover > .MuiBox-root": {
            backgroundColor: theme.palette.grey[100],
            transition: "background-color 0.2s",
          },
          "&:hover": {
            backgroundColor: "transparent",
          },
        })}
        {...props}>
        <Box
          sx={(theme) => ({
            width: theme.spacing(5),
            height: theme.spacing(5),
            padding: theme.spacing(0.75),
            border: `1px solid ${theme.palette.grey[200]}`,
            borderRadius: "50%",
          })}>
          {icon}
        </Box>
        <Typography ml={1.5}>{children}</Typography>
      </Button>
    );
  }
);
